import React from "react";

const AntisocialForcesSection = (props) => {
  return (
    <div className="antisocial-forces-container">
      <div className="title">反社会的勢力への対応</div>
      <div className="text">
        野村グループでは、全ての役員・社員が遵守すべき指針である「野村グループ倫理規程」の中で、「反社会的勢力または団体との一切の取引を行わない」旨を定めており、反社会的勢力との関係を全て遮断することを基本方針としております。
        <br />
        <br />
        反社会的勢力排除に向けた基本的な考え方およびその整備状況につきましては、野村ホールディングスのコーポレート・ガバナンスに関する報告書をご覧ください。
      </div>
      <div className="link">
        <img alt="" src={require("@/assets/images/arrow-right.svg")} />
        <a href="#" className="text">
          コーポレート・ガバナンスに関する報告書
        </a>
      </div>
    </div>
  );
};

export default AntisocialForcesSection;
